"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authDrawContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.authDrawContract = c.router({
    getDrawEntriesWithRealAndHypotheticalPrizes: {
        method: 'GET',
        path: '/results-reveal/entries-with-real-and-hypothetical-prizes/:draw_id',
        pathParams: zod_1.z.object({
            draw_id: zod_1.z.coerce.number(),
        }),
        responses: {
            200: zod_1.z.array(models_1.ZDrawEntry),
        },
    },
    getPlayersUpcomingDrawDate: {
        method: 'GET',
        path: '/upcoming-draw-date',
        responses: {
            200: zod_1.z.object({
                upcomingDrawDate: zod_1.z.coerce.date().nullable(),
            }),
        },
    },
}, {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=draw.auth.contract.js.map